import React, { FC } from 'react';
import { useCountDown } from '@hooks/useCountDown';
import { useLocation } from 'react-router-dom';

interface CountdownDisplayProps {
  userInfo: any;
}

const CountdownDisplay: FC<CountdownDisplayProps> = ({ userInfo }) => {
  const location = useLocation();

  useCountDown({
    minutes: 5,
    isUserActive: !location.pathname.includes('/authorization/login'),
  });

  if (userInfo?.associated !== 1) {
    return null;
  }

  return <span data-test-id="c-countdown-display" />;
};

export default React.memo(CountdownDisplay);
